import { connect } from 'react-redux';
import LineDetails from './LineDetails';
import { getFormValues, reset, destroy, isDirty } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';

const FORM_NAME = 'CreditNotesLineDetailsForm';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty(FORM_NAME)(state),
  formValues: getFormValues(FORM_NAME)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    changeConfirmationDialog: uiActions.changeConfirmationDialog,
    resetForm: () => reset(FORM_NAME),
    destroyForm: () => destroy(FORM_NAME),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LineDetails);
